import { UserAccount } from '../api/schemas/schema'

export const getFullName = (account: UserAccount) => {
   if (!account || !account.firstName || !account.lastName) return null
   return `${account.firstName} ${account.lastName}`
}
